module.exports = __webpack_public_path__ + "static/media/noun-faq.c3e4e3a2.svg";